export const getEnv = (env: string) => {
  if (env === 'prod' || env === 'production') {
    return 'prod';
  }

  return 'dev';
};
